import { Component, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AtbHomeService } from "../../../services/atbHome.service";
import { NgForm } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import swal2 from "sweetalert2";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { Subscription } from "rxjs";
import { defineLocale } from "ngx-bootstrap/chronos";
import { itLocale } from "ngx-bootstrap/locale";
import { environment } from '../../../../environments/environment';
defineLocale("it", itLocale);

declare var jQuery: any;
@Component({
  selector: "app-voucher-covid-list",
  templateUrl: "./voucher-covid-list.component.html",
  styleUrls: ["../../../app.component.css"]
})
export class VoucherCovidListComponent implements OnInit {

  voucherCovidPath;
  requestsPath;
  requestsFullPath;
  pdfPath;

  checkFirstPage;
  private sub: any;

  vouchers: any[] = new Array();
  requestData = {
    numeroTessera: ''
  };
  requestFullData = {
    numeroTessera: '',
    codiceFiscale: ''
  };
  visibleRequestFull = false;
  errorMessage;
  voucher: any;

  @ViewChild("requestForm") requestForm: NgForm;
  @ViewChild("requestFullForm") requestFullForm: NgForm;

  constructor(
    private route: ActivatedRoute,
    private modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private atbService: AtbHomeService
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {

      if ( params['token'] == undefined  ||  params['token'] == null ||  params['token'] == "" ) {
        this.checkFirstPage = false
      } else{
        this.checkFirstPage = true
      }
    });


    if (this.checkFirstPage == true)  {

      this.sub = this.route.params.subscribe(params => {
        var token  = params['token'];
        var user = params['user'];
        var language = params['language'];
        var role = params['role'];

        localStorage.setItem("token", token);
        localStorage.setItem("user", user)
        localStorage.setItem("language", language)
        localStorage.setItem("role", role)
        this.router.navigate(['/voucher-covid/list'])
      });

    }

    this.voucherCovidPath = 'voucher/covid'
    this.requestsPath = 'richieste'
    this.requestsFullPath = 'richiesteconverifiche'
    this.pdfPath = 'pdf'
    this.getVoucherCovidRequested();

    localStorage.removeItem("voucherRequestData")
  }

  getVoucherCovidRequested() {
    this.spinner.show();

    this.atbService.getListFilter(this.voucherCovidPath + '/' + this.requestsPath).subscribe(
      (response) => {
        if (response.outcome.success === true) {
          this.vouchers = response.results
        }
        this.spinner.hide()
      },
      (error) => {
        console.log('Error ', error);
        this.spinner.hide()
      }
    );
  }

  downloadPdf(voucher) {
    const link = document.createElement('a');
    link.href = environment.restBaseUrl + this.voucherCovidPath + '/' + this.pdfPath + '/' + voucher.numeroVoucher;
    link.download = 'Voucher_' + voucher.numeroVoucher + '.pdf';
    link.click();
  }

  requestVoucher() {
    this.spinner.show();
    let showError = true;
    this.atbService.newObject(this.requestData, this.voucherCovidPath + '/' + this.requestsPath).subscribe(
      (response) => {
        if (response.outcome.success === true) {
          this.voucher = response.result
          this.doRequest();
        } else {
          switch (response.outcome.code) {
            case '0002':
              this.errorMessage = 'Questa B-Card non esiste';
              break;
            case '0021':
              this.errorMessage = 'Ci dispiace, non hai diritto al voucher. Per maggiori informazioni contattata ATB';
              break;
            case '0022':
              showError = false;
              this.errorMessage = 'Questa B-Card non risulta associata al corrente account. Effettuare la verifica con codice fiscale dell\'intestatario';
              this.requestFullData.numeroTessera = this.requestData.numeroTessera;
              this.visibleRequestFull = true;
              this.requestForm.reset();
              break;
            case '0023':
              this.errorMessage = 'Attenzione! Questa B-Card risulta associata ad un altro account. Contatta ATB per maggiori verifiche';
              break;
            case '0024':
              this.errorMessage = 'Attenzione! Questa B-Card ha già effettuato la richiesta del voucher';
              break;
            default:
              this.errorMessage = 'Qualcosa è andato storto';
              break;
          }
          if (showError) {
            swal2('Attenzione', this.errorMessage, 'warning');
          }
        }
        this.spinner.hide()
      },
      (error) => {
        console.log('Error ', error);
        this.errorMessage = 'Spiacente, si è verificato un errore tecnico.';
        swal2('Attenzione', this.errorMessage, 'warning');
        this.spinner.hide()
      }
    );
  }

  requestFullVoucher() {
    this.spinner.show();
    this.atbService.newObject(this.requestFullData, this.voucherCovidPath + '/' + this.requestsFullPath).subscribe(
      (response) => {
        if (response.outcome.success === true) {
          this.voucher = response.result
          this.doRequestFull();
        } else {
          switch (response.outcome.code) {
            case '0002':
              this.errorMessage = 'Questa B-Card non esiste';
              break;
            case '0021':
              this.errorMessage = 'Ci dispiace, non hai diritto al voucher. Per maggiori informazioni contattata ATB';
              break;
            case '0025':
              this.errorMessage = 'Questa B-Card risulta già associata ad un account';
              break;
            case '0026':
              this.errorMessage = 'Attenzione! La B-Card non risulta associata a questo codice fiscale';
              break;
            case '0024':
              this.errorMessage = 'Attenzione! Questa B-Card ha già effettuato la richiesta del voucher';
              break;
            default:
              this.errorMessage = 'Qualcosa è andato storto';
              break;
          }
          swal2('Attenzione', this.errorMessage, 'warning');
        }
        this.spinner.hide()
      },
      (error) => {
        console.log('Error ', error);
        this.errorMessage = 'Spiacente, si è verificato un errore tecnico.';
        swal2('Attenzione', this.errorMessage, 'warning');
        this.spinner.hide()
      }
    );
  }

  resetRequest() {
    this.visibleRequestFull = false;
    this.requestFullForm.reset();
  }

  doRequest() {
    const requestData = {
      ...this.requestData,
      numeroVoucher: this.voucher.numeroVoucher,
      minore: this.voucher.minore
    }
    localStorage.setItem('voucherRequestData', JSON.stringify(requestData))
    this.router.navigate(['/voucher-covid/manage'])
  }

  doRequestFull() {
    const requestFullData = {
      ...this.requestFullData,
      numeroVoucher: this.voucher.numeroVoucher,
      minore: this.voucher.minore
    }
    localStorage.setItem('voucherRequestData', JSON.stringify(requestFullData))
    this.router.navigate(['/voucher-covid/manage'])
  }
  
}



// WEBPACK FOOTER //
// ./src/app/views/voucher-covid/voucher-covid-list/voucher-covid-list.component.ts